var _g, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDropdownBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 351,
    height: 377,
    viewBox: "0 0 351 377",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_873_2654)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_873_2654",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H351V377H0V0Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0 0H351V377H0V0Z",
    fill: "#475484"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.801 16L164.755 0H1.3354L-7.16309 16H154.801Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.236 377L361 361H118.605L106 377H346.236Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0V-4H-1V0H0ZM351 0H352V-4H351V0ZM351 377V381H352V377H351ZM0 377H-1V381H0V377ZM0 4H351V-4H0V4ZM350 0V377H352V0H350ZM351 373H0V381H351V373ZM1 377V0H-1V377H1Z",
    fill: "white",
    mask: "url(#path-1-inside-1_873_2654)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_873_2654"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H351V377H0V0Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdownBg);
export default __webpack_public_path__ + "static/media/dropdown_bg.40a5e278147071ea8824ed1abf8bcb06.svg";
export { ForwardRef as ReactComponent };